// Copyright © 2021 Move Closer
import { AbstractTypeDriver } from './abstract';
import { RelatedType } from '../contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class FileDriver extends AbstractTypeDriver {
    constructor() {
        super(...arguments);
        /**
         * Key that stores RelatedType.
         * @protected
         */
        this.typeKey = RelatedType.File;
        this.cdnUrl = 'https://cdn.defence24.pl/';
    }
    /**
     * @inheritDoc
     */
    resolve(id, record, config, driverResolver) {
        const file = super.resolve(id, record, config, driverResolver);
        if (file.url && !file.url.startsWith('http')) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            file.url = `${this.cdnUrl}${file.url}`;
        }
        return file;
    }
    /**
     * @inheritDoc
     */
    describe(id, record) {
        const file = super.describe(id, record);
        if (file.url && !file.url.startsWith('http')) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            file.url = `${this.cdnUrl}${file.url}`;
        }
        return file;
    }
}
